var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"routeList"},_vm._l((_vm.routeList),function(item){return _c('span',{key:item.path,staticClass:"cursor-pointer",class:{ active: _vm.$route.path === item.path },on:{"click":function($event){return _vm.goRoute(item)}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }